import React from "react";
import { Link } from "gatsby";
import linnkedin from "../images/footer-linkedin.png";
import twitter from "../images/Footer-twitter.png";
import instagram from "../images/footer-instagram.png";
import facebook from "../images/footer-facebook.png";

export const FooterTwo = () => {
  return (
    <div className="footer ">
      <div className="footer-three-bg">
        <div className="container pt-0">
          <div className=" row overlay-footer-three d-flex justify-content-center align-items-center">
            <div className=" col-lg-4 col-12 footer-three-content-one d-flex justify-content-center justify-content-md-start align-items-center">
              ©2025 Deerhold Ltd. | All Rights Reserved
            </div>
            <div className="col-lg-4 col-12 footer-three-content-two d-flex justify-content-center align-items-center gap-4">
              <div className="termofuse">
                <a href="terms-of-use" target="_blank">
                  Terms of Use
                </a>
              </div>
              <div className="privacy">
                <a href="privacy-policy" target="_blank">
                  Privacy Policy
                </a>
              </div>
            </div>
            <div className="  col-lg-4 footer-three-content-three-social-media d-flex justify-content-center">
              <div className="footer-linkedin">
                <a
                  href="https://www.linkedin.com/company/deerhold"
                  target="_blank"
                >
                  <img src={linnkedin} width="21" />
                </a>
              </div>
              <div className="footer-twitter">
                <a href="https://twitter.com/deerholdltd" target="_blank">
                  <img src={twitter} width="21" />
                </a>
              </div>
              <div className="footer-instagram">
                <a href="https://www.instagram.com/deerhold/" target="_blank">
                  <img src={instagram} width="21" />
                </a>
              </div>
              <div className="footer-facebook">
                <a href="https://www.facebook.com/deerhold" target="_blank">
                  <img src={facebook} width="21" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="links-second-footer"></div>
    </div>
  );
};

export default FooterTwo;
